import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

const sagaMiddleware = createSagaMiddleware();

export function createReduxStore(reducer, reducerName, rootSaga) {
  const reducers = combineReducers({
    [reducerName]: reducer
  });
  const composeEnhancers = composeWithDevTools({ name: reducerName });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));
  let store = createStore(reducers, middleware);
  sagaMiddleware.run(rootSaga);
  return store;
}
